<template>
  <div id="ProjBidQuotedListCard" :class="project.quoteStatus == '6' ? 'zhong' : ''">
    <div class="list-header">
      <div class="list-header-left ellipsis">
        <el-tooltip effect="dark" :content="project.projectName" placement="top">
          <router-link :to="'/projbid/demand/' + project.projectId + '/' + project.supplierUserId">
            {{ project.projectName }}
          </router-link>
        </el-tooltip>
      </div>
      <div class="list-header-right">
        <el-button
          @click="gotoNotarizationWechatPayPage()"
          v-if="project.notarizationStatus == 1 && project.quoteStatus == 6 && userId == project.supplierUserId"
          class="eb-button-red eb-button-small eb-button-flashed"
          >支付鉴证费</el-button
        >
        <!-- <router-link :to="'/projbid/demand/'+project.projectId+ '/' + project.supplierUserId"> -->
        <el-button @click="isCheckAuth(project.projectId, project.supplierUserId)" class="eb-button-red eb-button-small"
          >查看需求</el-button
        >
        <!-- </router-link> -->
        <!-- <router-link v-if="!(project.quoteStatus == 9 || project.quoteStatus == 6|| project.quoteStatus == 11) && userId == project.supplierUserId "
          :to="'/projbid/reply/ruleedit/' + this.project.projectId + '/' + project.replyId"> -->
        <el-button
          v-if="
            !(
              project.quoteStatus == 9 ||
              project.quoteStatus == 6 ||
              project.quoteStatus == 11 ||
              project.quoteStatus == 12 ||
              project.quoteStatus == 10
            ) && userId == project.supplierUserId
          "
          @click="isCheckEditAuth(project.projectId, project.replyId)"
          class="eb-button-red eb-button-small"
          >编辑报价</el-button
        >
        <!-- </router-link> -->
        <ProjBidBtnDeleteQuoteList
          @onDeleteQuote="onDeleteQuote"
          v-if="(project.quoteStatus == 1 || project.quoteStatus == 2) && userId == project.supplierUserId"
          :project="project"
          class="eb-button-red eb-button-small"
        />
        <router-link
          v-if="
            (project.quoteStatus == 9 ||
              project.quoteStatus == 6 ||
              project.quoteStatus == 11 ||
              project.quoteStatus == 12 ||
              project.quoteStatus == 10) &&
            userId == project.supplierUserId
          "
          :to="'/projbid/reply/detail/' + project.projectId + '/' + project.replyId + '/' + project.supplierUserId"
        >
          <el-button class="eb-button-red eb-button-small">查看报价</el-button>
        </router-link>
        <router-link
          v-if="roleId == '9' && !(userId == project.supplierUserId)"
          :to="'/projbid/reply/detail/' + project.projectId + '/' + project.replyId + '/' + project.supplierUserId"
        >
          <el-button class="eb-button-red eb-button-small">查看报价</el-button>
        </router-link>
      </div>
    </div>
    <div class="list-body">
      <div class="list-body-left">
        <img v-if="project.projectImages" :src="project.projectImages" alt="项目图片" />
        <img v-if="!project.projectImages" :src="$ebConfig.imgPath + 'img/project-default.jpg'" alt="项目图片" />
      </div>
      <div class="list-body-right">
        <div class="card-three-row">
          <div class="col-210">
            <div class="col-left">项目编号:</div>
            <div class="col-right">
              <el-tooltip :content="project.projectCode" placement="top">
                <span class="col-right-content"> {{ project.projectCode }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-242">
            <div class="col-left">当前状态:</div>
            <div class="col-right">
              <span class="col-right-content"> {{ project.quoteStatus | projBidQuoteStatus }}</span>
            </div>
          </div>
          <div class="col-135">
            <eb-font-type>{{ project.projectMethod | projectMethod(true) }}</eb-font-type>
            <eb-font-type>{{ project.projectType | projectType(true) }}</eb-font-type>
          </div>
          <div class="col-218">
            <eb-share />
          </div>
        </div>
        <div class="card-three-row">
          <div class="col-452">
            <div class="col-left">采购单位:</div>
            <div class="col-right">
              <el-tooltip :content="project.buyDepartName || '-'" placement="top">
                <span @click="conpanyInfo" class="col-right-content conpanyInfo">
                  {{ project.buyDepartName || '-' }}</span
                >
              </el-tooltip>
            </div>
          </div>
          <div class="col-135">
            <div class="col-left">采购经办:</div>
            <div class="col-right">
              <img
                @click="userInfoDialog(project.buyUserId)"
                class="header_img"
                v-if="project.buyUserheadImg"
                :src="buyUserheadSrc"
              />
              <img
                @click="userInfoDialog(project.buyUserId)"
                class="header_img"
                v-if="!project.buyUserheadImg"
                :src="$ebConfig.imgPath + 'img/user-default.jpeg'"
              />
            </div>
          </div>
          <div class="col-218">
            <div class="col-left">发布时间:</div>
            <div class="col-right">
              <el-tooltip :content="project.startTime | dateFormatYMDH" placement="top">
                <span class="col-right-content"> {{ project.startTime | dateFormatYMDH }}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="card-three-row">
          <div class="col-210">
            <div class="col-left">当前报价:</div>
            <div class="col-right">
              <el-tooltip :content="project.quoteMin | formatCurrency" placement="top">
                <span class="col-right-content"> {{ project.quoteMin | formatCurrency }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-242 componyInfoCol">
            <div class="col-left">供方单位:</div>
            <div class="col-right">
              <el-tooltip :content="project.supplierDepartName || '-'" placement="top">
                <span class="col-right-content"> {{ project.supplierDepartName || '-' }}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-135">
            <div class="col-left">供方代表:</div>
            <div class="col-right">
              <img
                @click="userInfoDialog(project.supplierUserId)"
                class="header_img"
                v-if="project.supplierUserheadImg"
                :src="supplierUserheadImgSrc"
              />
              <img
                @click="userInfoDialog(project.supplierUserId)"
                class="header_img"
                v-if="!project.supplierUserheadImg && project.supplierUserId"
                :src="$ebConfig.imgPath + 'img/user-default.jpeg'"
              />
            </div>
          </div>
          <div class="col-218">
            <div class="col-left">报价截止:</div>
            <div class="col-right">
              <el-tooltip :content="project.endTime | dateFormatYMDH" placement="top">
                <span class="col-right-content"> {{ project.endTime | dateFormatYMDH }}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ebFontType from '@/components/common/eb-font-type';
import ebShare from '@/components/common/share/eb-share';
import ProjBidBtnDeleteQuoteList from '@/components/project/bid/list/ProjBidBtnDeleteQuoteList';
import eventBus from '@/plugins/event-bus';
import { isCheckSupplierBtnAuth } from '@/services/proj/bid-project-service';
import { getNotarizationInfo } from '@/services/notarization/notarization-service';
import { baseURL } from '@/plugins/axios';
// import { isMySupplier } from '@/services/user/user-supplier-service';
export default {
  name: 'ProjBidQuotedListCard',
  props: ['project'],
  components: {
    ebFontType,
    ebShare,
    ProjBidBtnDeleteQuoteList
  },
  data() {
    return {
      roleId: this.$store.state.user.userInfo.roleid + '',
      userId: this.$store.state.user.userInfo.userid
    };
  },
  computed: {
    buyUserheadSrc: {
      cache: true,
      get: function() {
        return baseURL + this.project.buyUserheadImg + '?time=' + Date.now();
      }
    },
    supplierUserheadImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.project.supplierUserheadImg + '?time=' + Date.now();
      }
    }
  },
  methods: {
    onDeleteQuote: function() {
      this.$emit('onDeleteQuote');
    },
    userInfoDialog: function(userId) {
      eventBus.$emit('userInfoDialog', userId);
    },
    conpanyInfo() {
      window.open('/buyer/detail/' + this.project.orgId);
    },
    async isCheckAuth(projectId, supplierUserId) {
      let params = {
        projectId: projectId,
        type: '2'
      };
      try {
        let { data } = await isCheckSupplierBtnAuth(params);
        if (data.returnCode === '01') {
          this.$router.push('/projbid/demand/' + projectId + '/' + supplierUserId);
        } else if (data.returnCode === '00') {
          this.$message.error(data.message);
          return;
        } else {
          this.$message.error('操作失败');
        }
      } catch (error) {
        this.$message.error('网络异常请稍后重试');
      }
    },
    async isCheckEditAuth(projectId, replyId) {
      let params = {
        projectId: projectId,
        type: '3'
      };
      try {
        let { data } = await isCheckSupplierBtnAuth(params);
        if (data.returnCode === '01') {
          this.$router.push('/projbid/reply/ruleedit/' + projectId + '/' + replyId);
        } else if (data.returnCode === '00') {
          this.$message.error(data.message);
          return;
        } else {
          this.$message.error('操作失败');
        }
      } catch (error) {
        this.$message.error('网络异常请稍后重试');
      }
    },
    async gotoNotarizationWechatPayPage() {
      try {
        let params = {
          projectId: this.project.projectId,
          projectMethod: '2'
        };
        let { data } = await getNotarizationInfo(params);
        if (data.returnCode === '01' || data.returnCode === '00') {
          let params1 = {
            notarization: data.notarization,
            refreshUrl: '/projbid/quoted/list'
          };
          eventBus.$emit('initNotarizationPaymentData', params1);
        } else {
          this.$message.error('获取合规鉴证信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  }
};
</script>
<style  lang="less">
#ProjBidQuotedListCard {
  &.zhong {
    background: url('../../../../assets/img/zhong.png') no-repeat 55% 0;
  }
  .list-header {
    display: flex;
    flex-wrap: wrap;
  }
  .list-header-left {
    height: 52px;
    width: 55%;
    line-height: 52px;
    a {
      color: #060606;
      font-weight: 700;
      font-family: 'Microsoft YaHei';
    }
  }
  .list-header-right {
    padding-top: 13px;
    width: 44%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .list-body {
    display: flex;
    flex-wrap: wrap;
  }
  .list-body-left {
    height: 135px;
    width: 18.3%;
    display: flex;
    img {
      margin: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .list-body-right {
    width: 80.6%;
    padding-left: 1%;
  }
  .eb-button-red {
    margin-left: 10px;
  }
  .header_img {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin-top: 8px;
    cursor: pointer;
  }
  .font-type {
    margin-right: 11px;
  }
  .conpanyInfo {
    cursor: pointer;
  }
}
</style>
